<template>
  <div class="top_title">
    <div class="top_name title_size position-relative">
      <div  class="w-100 h-100 d-flex justify-content-between position-absolute top-0">
        <div class="d-flex problem-describtion text-color">
          <i v-if="snData.isRolling" @click="goback" class="ri-close-line"></i>
          <div class="d-flex" v-if="inputType">{{nameChange}}<i @click="inputType=false" class="ri-pencil-line"></i></div>
          <div class="d-flex" v-else><input @input="inputChange($event)" class="input-underline" type="text" v-model="nameChange" /><i @click="editField" class="ri-check-line"></i></div>
        </div>
        <div>{{$t('overview_static.customer_page.serial_numner') +' ' +snNum}}</div>
      </div>

      <div
        v-if="showButton"
        class="button_icon"
        :style="buttonStyle"
        @click="buttonClick(false)"
      >
          {{buttonName}}
      </div>
    </div>
    <!-- 生产状态 -->
    <div class="output_status">
      <img :src="imageLists.divider" alt="" />
    </div>
  </div>
</template>

<script>
// import {SERVICE_STATUS_PENDING, SERVICE_STATUS_TO_BE_CLASSIFIED} from "@/config/common";
import {instanceName} from "@/service";

export default {
  emits:['changeReverse'],
  name: "Top",
  data() {
    return {
      imageLists: {
        divider: require("@/assets/images/icon-divider.svg")
      },
      inputType:true,
      inputName:name
    };
  },
  props: {
    snNum:{
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    snIndex: {
      type: Number,
      default:0
    },
    showButton: {
      type: Boolean,
      default: false
    },
    buttonName: {
      type: String,
      default: ""
    },
    snData:{
      type: Object,
      default: null
    },
    buttonStyle: {
      type: Object,
      default: null
    },
    buttonClick: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    goback(){
      let id;
      if(this.snData.children&&this.snData.isRolling){
        this.snData.children.map(item=>{
          if(this.name.includes(item.name)){
            id=item.id
          }
        })
      }
      this.$emit('changeReverse',this.snIndex, this.snData, this.inputName, id,'back')
    },
    inputChange(e){
        console.log(e.target.value)
      this.inputName = e.target.value
    },
    editField() {
      console.log(this.name,this.inputName)
      let id;
      if(this.snData.children&&this.snData.isRolling){
        this.snData.children.map(item=>{
          if(this.snNum==item.sn){
            console.log(this.name,item.name)
            id=item.id
          }
        })
      }else{
        id=this.snData.id
      }
      let params={name:this.inputName}
      instanceName(params,id).then(res=>{
        console.log(res)
        this.inputType=true
        this.$emit('changeReverse',this.snIndex, this.snData, this.inputName, id)

      })
    },
  },
  computed:{
    nameChange(){
      return this.name || ''
    }
  }
};
</script>

<style scoped lang="scss">
.top_title {
  width: 100%;
  line-height: 20px;
}
.top_name {
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  font-weight: 400;
  height:30px;
  width: 100%;
}
.button_icon {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 4px 5px;
  font-size: 12px;
  &:hover {
    cursor: pointer;
  }
}
.output_status {
  width: 100%;
  line-height: 10px;
  background-size: cover;
  background-repeat: no-repeat;
}
.input-underline {
  border-bottom: 1px solid #dbdbdb;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  outline: none;
  background: transparent;
}
</style>
